import { CanvasRenderingTarget2D } from 'fancy-canvas'
import { IPrimitivePaneRenderer } from 'lightweight-charts'
import PlusIconDrawing from './plusIcon.drawing'
import {
    CHART_PLUS_BUTTON_BACKGROUND,
    CHART_PLUS_BUTTON_BACKGROUND_HOVER
} from '../../../chartV2/chartContextMenuButton/chartPlusButtonColors'

export const SQUARE_WIDTH = 20;

class PlusIconPaneRenderer implements IPrimitivePaneRenderer {
    drawing: PlusIconDrawing

    constructor(drawing: PlusIconDrawing) {
        this.drawing = drawing;
    }

    draw(target: CanvasRenderingTarget2D) {

        if (!this.drawing.chart) return;

        target.useBitmapCoordinateSpace(scope => {
            const { horizontalPixelRatio, verticalPixelRatio, mediaSize: {height}, context: ctx } = scope
            const { price, visible } = this.drawing.options

            if (!visible) return;
            const xCoordinate = this.drawing.chart.timeScale().timeToCoordinate(price);
            

            if (!xCoordinate) return;

            const scaledX = xCoordinate*horizontalPixelRatio;
            const scaledY = height*verticalPixelRatio;

            const squareWidth = SQUARE_WIDTH * horizontalPixelRatio
            const radius = 3 * horizontalPixelRatio
            const plusIconWidth = 1.5 * horizontalPixelRatio
            const {
                hovered,
                fillColor = CHART_PLUS_BUTTON_BACKGROUND,
                hoverFillColor = CHART_PLUS_BUTTON_BACKGROUND_HOVER
            } = this.drawing.options
            const squareFill = hovered ? hoverFillColor : fillColor

            this.drawRoundedSquare(ctx, scaledX - (squareWidth / 2), scaledY - squareWidth, squareWidth, radius, squareFill)
            this.drawPlusIcon(ctx, scaledX - (squareWidth / 2), scaledY - squareWidth, squareWidth, squareWidth / 2, plusIconWidth, 'white')
        })
    }

    drawRoundedSquare(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, radius: number, fillColor: string) {
        ctx.beginPath();

        // Top-left corner (rounded)
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + size - radius, y);
        ctx.arcTo(x + size, y, x + size, y + radius, radius);

        // Right side and bottom-right (no radius)
        ctx.lineTo(x + size, y + size);

        // Bottom side and bottom-left (no radius)
        ctx.lineTo(x, y + size);

        // Left side up to top-left (rounded)
        ctx.lineTo(x, y + radius);
        ctx.arcTo(x, y, x + radius, y, radius);

        ctx.closePath();

        ctx.fillStyle = fillColor;
        ctx.fill();
    }

    drawPlusIcon(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, lineLength = 20, lineWidth = 2, color = 'black') {
        const centerX = x + size / 2;
        const centerY = y + size / 2;

        ctx.beginPath();
        ctx.strokeStyle = color;
        ctx.lineWidth = lineWidth;

        // Draw circle around the plus
        const circlePadding = 5; // adjust as needed to fit around the plus
        const radius = lineLength / 2 + circlePadding;
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.stroke();

        // Draw plus sign
        ctx.beginPath();
        ctx.strokeStyle = color;
        ctx.lineWidth = lineWidth;

        // Vertical line
        ctx.moveTo(centerX, centerY - lineLength / 2);
        ctx.lineTo(centerX, centerY + lineLength / 2);

        // Horizontal line
        ctx.moveTo(centerX - lineLength / 2, centerY);
        ctx.lineTo(centerX + lineLength / 2, centerY);
        ctx.closePath();
        ctx.stroke();
    }
    
    destroy() {
        this.drawing = null;
    }
}


export default PlusIconPaneRenderer